export const useFixedQuasarScroll = () => {
  const $q = useQuasar()

  $q.screen.setSizes({
    sm: 293,
    md: 576,
    lg: 960,
    xl: 1119,
  })

  const fixScroll = () => {
    if ($q.screen.gt.md) {
      document.body.classList.remove('q-body--prevent-scroll')
      document.body.style.overflow = ''
      const headerEl = document.querySelector('.q-header')
      headerEl?.classList.remove('q-header--revealed', 'q-header--hidden')
      window.dispatchEvent(new Event('scroll'))

      const layoutEl = document.querySelector('.q-layout')
      layoutEl?.dispatchEvent(new Event('scroll'))
    }
  }

  watch(
    () => $q.screen.width,
    () => {
      fixScroll()
    }
  )
  fixScroll()
}
